import { lightColors, primitiveColors } from "styles/designSystemVars"

export default {
  // default
  defaultShadow: "0px 2.882px 2.882px 0px rgba(0, 0, 0, 0.05)",
  defaultActiveColor: lightColors.colorBrandTextDefault,
  defaultHoverColor: lightColors.colorBrandTextDefault,
  defaultShadow: "0",
  defaultGhostColor: primitiveColors.transparentWhite0,

  // text and font
  fontWeight: 450,
  colorText: lightColors.colorBrandTextDefault,
  colorBgTextActive: primitiveColors.transparentWhite0,
  textHoverBg: primitiveColors.transparentWhite0,
  // link
  colorLink: lightColors.colorBrandTextDefault,
  colorLinkActive: lightColors.colorBrandTextDefault,
  colorLinkHover: lightColors.colorBrandTextDefault,
  fontWeight: 600,

  // primary and background
  colorPrimary: lightColors.colorBrandBgDefault,
  colorPrimaryHover: lightColors.colorBrandBgHover,
  colorPrimaryActive: lightColors.colorBrandBgPressed,
  defaultHoverBg: lightColors.colorBrandBgSoftHover,
  defaultActiveBg: lightColors.colorBrandBgSoftPressed,
  primaryShadow: "0",
  primaryColor: lightColors.colorTextInverseDefault,

  // padding
  paddingInline: 19,
  paddingInlineLG: 19,
  paddingInlineSM: 11,

  // icon
  onlyIconSize: 18,
  onlyIconSizeLG: 20,
  onlyIconSizeSM: 16,

  // border
  colorBorder: lightColors.colorBrandBorderDefault,
  defaultBorderColor: lightColors.colorBrandBorderDefault,
  defaultHoverBorderColor: lightColors.colorBrandBorderDefault,
  defaultActiveBorderColor: lightColors.colorBrandBorderDefault,
  defaultGhostBorderColor: primitiveColors.transparentWhite0,
  colorPrimaryBorder: lightColors.colorBrandBorderDefault,
  groupBorderColor: lightColors.colorBrandBorderDefault,
  borderRadiusSM: 10,
  borderRadius: 10,
  borderRadiusLG: 10,
  colorBorder: "#DBD9CA", // grey
  lineWidth: 1.131,

  // disabled
  colorBgContainerDisabled: lightColors.colorSchemeGrayBgDefault,
  colorTextDisabled: lightColors.colorDisabledTextDefault,
  borderColorDisabled: lightColors.colorSchemeGrayBgDefault,

  // critical/danger and error
  colorErrorHover: lightColors.colorCriticalBgHover,
  colorErrorActive: lightColors.colorCriticalBgPressed,
  colorErrorBg: primitiveColors.transparentWhite0,
  colorErrorBgActive: primitiveColors.transparentWhite0,
  colorErrorBorderHover: lightColors.colorCriticalBorderDefault,

  // control
  // controlHeight: 35,
  controlHeightLG: 40,
  controlHeightSM: 27,
}
